export const ApiRoutes = {
  CORE: import.meta.env.VITE_CORE_API_URL,
  AUTH: import.meta.env.VITE_AUTH_API_URL,
  SUPPLIER_BFF: import.meta.env.VITE_SUPPLIER_BFF_API_URL,
  MERCHANT_BFF: import.meta.env.VITE_MERCHANT_BFF_API_URL,
  CHECKOUT_BFF: import.meta.env.VITE_CHECKOUT_BFF_API_URL,
} as const
